/// <amd-module name="VSSUI/ResizeGroup" />
export { ResizeGroup, ResizeGroupContext } from "./Components/ResizeGroup/ResizeGroup";

export { IResizeGroupProps, IResizeGroupContext } from "./Components/ResizeGroup/ResizeGroup.Props";
export { OverflowButton } from "./Components/ResizeGroup/OverflowButton";
